import { render, staticRenderFns } from "./Topic2Core.vue?vue&type=template&id=64544a90&scoped=true"
import script from "./Topic2Core.vue?vue&type=script&lang=js"
export * from "./Topic2Core.vue?vue&type=script&lang=js"
import style0 from "./Topic2Core.vue?vue&type=style&index=0&id=64544a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64544a90",
  null
  
)

export default component.exports